module.exports = __webpack_public_path__ + "static/media/Icons_Idle_02_Productivity.a220a875.svg";